const sedativePrescriptionRequestedInSafetyQuestions = (safetyQuestions: any, studyID: string) => {
  // return true if prescription requested, false if not requested or not claustrophobic
  const safetyQuestionsForStudy = safetyQuestions[studyID];
  if (!safetyQuestionsForStudy) {
    return false;
  }
  if (Object.keys(safetyQuestionsForStudy).length === 0){
    return false;
  }
  if (
    safetyQuestionsForStudy['Safety.SafetyQuestions.Claustrophobic.OralSedative'] ===
    'no'
  ) {
    return false;
  }
  if (
    !safetyQuestionsForStudy['Safety.SafetyQuestions.Claustrophobic.OralSedativePrescription'] ||
    safetyQuestionsForStudy['Safety.SafetyQuestions.Claustrophobic.OralSedativePrescription'] ===
    'no'
  ) {
    return false;
  }
  return safetyQuestionsForStudy['Safety.SafetyQuestions.Claustrophobic.Status'] === 'yes';
};

export default sedativePrescriptionRequestedInSafetyQuestions;
